module.exports = {
  title: '投稿系统',
  examTitle: '考试系统'
}
